import React from 'react'; // Import React for JSX in renderNameFilters
import { Input, Checkbox } from 'antd';

export const extractCombinedNames = (initiatives, key) => {
  return [
    ...new Set(
      initiatives.flatMap(
        (initiative) => initiative[key]?.map((item) => `${item.firstName} ${item.lastName}`) || []
      )
    ),
  ];
};

export const extractActionOwnerNames = (actionItem) => {
  return [
    ...new Set(
      actionItem
        .map((item) => item.owner)
        .filter(Boolean)
        .filter((owner) => owner !== undefined && owner !== null)
    ),
  ];
};

export const extractNames = (initiatives, key) => {
  return [
    ...new Set(
      initiatives.flatMap((initiative) => initiative[key]?.map((item) => item.name) || [])
    ),
  ];
};

export const renderNameFilters = (
  names,
  filterKey,
  attributeFilters,
  setAttributeFilters,
  searchTerm,
  setSearchTerm
) => {
  // Add "<not set>" to the list of names
  const namesWithNotSet = [...names, '<not set>'];

  const allSelected =
    attributeFilters[filterKey] === undefined ||
    attributeFilters[filterKey]?.length === namesWithNotSet.length;

  return (
    <div style={{ padding: '10px' }}>
      <Input
        placeholder="Search"
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: '10px' }}
      />
      <Checkbox
        indeterminate={
          attributeFilters[filterKey]?.length > 0 &&
          attributeFilters[filterKey]?.length < namesWithNotSet.length
        }
        checked={allSelected}
        onChange={(e) => {
          setAttributeFilters((prevFilters) =>
            e.target.checked
              ? { ...prevFilters, [filterKey]: namesWithNotSet }
              : { ...prevFilters, [filterKey]: [] }
          );
        }}
      >
        (Select all)
      </Checkbox>
      {namesWithNotSet
        .filter((item) => String(item).toLowerCase().includes(searchTerm.toLowerCase()))
        .map((item) => (
          <div key={item}>
            <Checkbox
              checked={
                attributeFilters[filterKey] === undefined ||
                attributeFilters[filterKey]?.includes(item)
              }
              onChange={(e) => {
                const newValue = e.target.checked
                  ? [...(attributeFilters[filterKey] || []), item]
                  : attributeFilters[filterKey]?.filter((val) => val !== item);
                setAttributeFilters((prevFilters) => ({
                  ...prevFilters,
                  [filterKey]: newValue,
                }));
              }}
            >
              {String(item)}
            </Checkbox>
          </div>
        ))}
    </div>
  );
};